import {  GridColDef } from '@mui/x-data-grid-premium';
import React, { useEffect, useMemo, useState } from 'react';
import { tableSettingsProps, useTableSettings } from '../tableSettings/useTableSettings';
import tableHelper from 'src/utils/tableHelper';
import { useGetDispatchOrdersByWarehouse, useGetDispatchOrdersRowsByWarehouse, useGetWarehouseLocationsById, useGetWarehouseStockById, useGetWarehouses } from '../../api/requestConfigs/warehouse';
import useUpdateEffect from 'src/hooks/useUpdateEffect';


export const useWarehousesTable = (): [columns: GridColDef[], tableSettings: tableSettingsProps] => {
  const rows = useGetWarehouses();
  const idPath = ["WarehouseId"];
  const columns: GridColDef[] = React.useMemo(
    () => [
      { field: 'actions', getActions: (params) => tableHelper.buttonColumn(params, "Edit", "/warehouse/warehouses/edit?id=", "WarehouseId", "Edit Warehouse"), type: 'actions', headerName: 'Edit', minWidth: 80, maxWidth: 120, flex: 0.8, },
      { field: 'WarehouseId', headerName: 'Warehouse Id', },
      { field: 'WarehouseName', headerName: 'Warehouse Name', flex:2 },
      { field: 'WarehouseType', headerName: 'Warehouse Type',flex:1 },
      { field: 'City', headerName: 'City', flex:1},
      { field: 'Country', headerName: 'Country', flex:1},
      { field: 'IsExternal', headerName: 'Is External',flex:1 ,minWidth:50, type:"boolean" },
      { field: 'IsActive', headerName: 'Is Active',flex:1 ,minWidth:50, type:"boolean" },
    ],
    [],
  );
  const tableName = "WarehousesTable";
  const tableSettings = useTableSettings({ columns,idPath, rows, tableName });
  useEffect(() => {
    tableSettings.setColumnVisibilityModel({
      WarehouseId: false,
      WarehouseType: false,
      IsExternal: false,
    });
  }, []);
  
  return [ columns, tableSettings];
};




export const usePackingStationsRowsTable = (initialValues): [columns: GridColDef[], tableSettings: tableSettingsProps] => {
  const [rows, setRows] = useState([])
  useUpdateEffect(() => {
    if (rows?.length < 1) {
      setRows(initialValues?.PackingStations ?? [])
    }
  }, [initialValues?.PackingStations])
  const columns: GridColDef[] = React.useMemo(
    () => [
      { field: 'Id', headerName: 'Id', type:"number"},
      { field: 'DeliveryNotePrinterId', headerName: 'Delivery Note Printer Id'},
      { field: 'Name', headerName: 'Name', flex:1},
      { field: 'ComputerName', headerName: 'Computer Name', flex:1},
      { field: 'WaybillPrinterId', headerName: 'Waybill Printer Id', type:"number"},


    ],
    [initialValues],
  );
  const tableName = "PackingStationsRowsTable";
  const tableSettings = useTableSettings({ columns, rows, tableName });
  tableSettings.autoHeight = true;
  tableSettings.hasToolbar=false;
  tableSettings.loading = false;
  
  return [ columns, tableSettings];
};

export const useReceivingStationsRowsTable = (initialValues): [columns: GridColDef[], tableSettings: tableSettingsProps] => {
  const [rows, setRows] = useState([])
  useUpdateEffect(() => {
    if (rows?.length < 1) {
      setRows(initialValues?.ReceivingStations ?? [])
    }
  }, [initialValues?.ReceivingStations])
  const columns: GridColDef[] = React.useMemo(
    () => [
      { field: 'Id', headerName: 'Id', type:"number"},
      
      { field: 'Name', headerName: 'Name', flex:1},
      { field: 'ComputerName', headerName: 'Computer Name', flex:1},
      { field: 'LabelPrinterName', headerName: 'Label Printer Name', flex:1},
      { field: 'LabelPrinterId', headerName: 'Label Printer Id', type:"number"},
      { field: 'ReceivingLocationName', headerName: 'Receiving Location Name', flex:1},
      { field: 'ReceivingLocationId', headerName: 'Receiving Location Id'},


    ],
    [initialValues],
  );
  const tableName = "ReceivingStationsRowsTable";
  const tableSettings = useTableSettings({ columns, rows, tableName });
  tableSettings.autoHeight = true;
  tableSettings.hasToolbar=false;
  tableSettings.loading = false;
  
  return [ columns, tableSettings];
};


export const useWarehouseLocationsTable = (editId): [columns: GridColDef[], tableSettings: tableSettingsProps] => {
  const rows = useGetWarehouseLocationsById(editId);
  const columns: GridColDef[] = React.useMemo(
    () => [
      { field: 'Id', headerName: 'Id',  type:"number" },
      { field: 'Label', headerName: 'Label', flex:1 },
      { field: 'WarehouseId', headerName: 'Warehouse Id',  type:"number" },
      { field: 'PartitionId', headerName: 'Partition Id',  type:"number" },
      
      
      
    ],
    [],
  );
  const tableName = "WarehouseLocationsTable";
  const tableSettings = useTableSettings({ columns, rows, tableName });
  tableSettings.hasToolbar=false;
  tableSettings.loading = false;
  return [ columns, tableSettings];
};
export const useWarehouseStocksTable = (editId): [columns: GridColDef[], tableSettings: tableSettingsProps] => {
  const rows = useGetWarehouseStockById(editId);
  const idPath=["ArticleNumber"];
  const columns: GridColDef[] = React.useMemo(
    () => [
      { field: 'SalesItemsId', headerName: 'Sales Items Id',  type:"number" },
      { field: 'ArticleNumber', headerName: 'Article Number',  type:"number" },
      { field: 'WarehouseQty', headerName: 'Warehouse Qty',  type:"number", flex:1 },
      { field: 'AvailableQty', headerName: 'Available Qty',  type:"number" },
      { field: 'OrderFulfillmentReservedQty', headerName: 'Order Fulfillment Reserved Qty',  type:"number" },
      { field: 'TransferOrderReservedQty', headerName: 'Transfer Order Reserved Qty',  type:"number" },
      
      
      
    ],
    [],
  );
  const tableName = "WarehouseStockTable";
  const tableSettings = useTableSettings({ columns,idPath, rows, tableName });
  
  tableSettings.hasToolbar=false;
  tableSettings.loading = false;
  return [ columns, tableSettings];
};




export const useDispatchOrderTable = (warehouseId): [columns: GridColDef[], tableSettings: tableSettingsProps] => {
  const {rows,status} = useGetDispatchOrdersByWarehouse(warehouseId);
  //console.log("Dispatch Order Table rows", rows);
  const columns: GridColDef[] = React.useMemo(
    () => [
      { field: 'DispatchOrderId', headerName: 'Id',  type:"number" },
      { field: 'OrderStatus', headerName: 'Status', renderCell: tableHelper.renderStatusCell},
      { field: 'DeliveryMethodName', headerName: 'Delivery Method', flex:2, minWidth:250 },
      { field: 'DispatchOrderType', headerName: 'Order Type',  flex:1, minWidth:150 },
      

      { field: 'CreateDate', headerName: 'Create Date',  },
      
      { field: 'ExternalOrderId', headerName: 'External Order Id' },
      { field: 'DeliveryMethodId', headerName: 'Delivery Method Id',  type:"number" },
      { field: 'WebOrderId', headerName: 'Web Order Id',  type:"number" },
      { field: 'WarehouseId', headerName: 'Warehouse Id',  type:"number" },
      { field: 'ExternalWarehouseStatus', headerName: 'External Warehouse Status',   },
    ],
    [],
  );
  const tableName = "DispatchOrderTable";
  const idPath=["DispatchOrderId"];

  useEffect(() => {
    tableSettings.setColumnVisibilityModel({
      DeliveryMethodId: false,
      WarehouseId: false,
      ExternalWarehouseStatus:false,
    })
  }, [columns])
  const tableSettings = useTableSettings({ columns, rows,status, tableName , idPath});
  tableSettings.hasToolbar=false;
  return [ columns, tableSettings];
};

export const useDispatchOrderRowsTable = (warehouseId, orderId): [columns: GridColDef[], tableSettings: tableSettingsProps,columns: GridColDef[], tableSettings: tableSettingsProps] => {
  const dispatchOrderData:any = useGetDispatchOrdersRowsByWarehouse(warehouseId, orderId);
  const rows = dispatchOrderData?.DispatchOrderRows ?? [];
  //console.log("Dispatch Order Table ROWS ROWS rows", rows,dispatchOrderData);
  const columns: GridColDef[] = React.useMemo(
    () => [
      { field: 'DispatchOrderRowId', headerName: 'Id',  type:"number" },
      { field: 'ProductId', headerName: 'Product Id',  type:"number" },
      { field: 'Product', headerName: 'Product', flex:1 },
      { field: 'ManufacturerProductId', headerName: 'Manufacturer Product Id', flex:1 },
      { field: 'OrderedQty', headerName: 'Ordered Qty',  type:"number"},
      { field: 'DispatchedQty', headerName: 'Dispatched Qty',  type:"number" },
      { field: 'ExternalDocumentRowId', headerName: 'External Document Row Id' },
      
   
    ],
    [],
  );
  const tableName = "DispatchOrderRowsTable";
  const idPath=["DispatchOrderRowId"];
  const tableSettings = useTableSettings({ columns, rows, tableName , idPath});
  tableSettings.hasToolbar = false;
  tableSettings.autoHeight = true;
  tableSettings.loading = false;
  tableSettings.hideFooter = true;
  const [additionalDataColumns, additionalDataTableSettings] = useDispatchOrderAdditionalDataTable(dispatchOrderData);
  return [ columns, tableSettings, additionalDataColumns, additionalDataTableSettings];
};


// {
//   "DispatchOrderBlockId": 0,
//   "DispatchOrderBlockReason": null,
//   "DispatchOrderId": 48,
//   "CreateDate": "2025-05-09T15:39:30",
//   "OrderStatusId": 1,
//   "OrderStatus": "New",
//   "WarehouseId": 1003,
//   "ExternalOrderId": 2000036,
//   "WebOrderId": null,
//   "DispatchOrderTypeId": 0,
//   "DispatchOrderType": "Customer Order",
//   "DispatchDate": null,
//   "Priority": 3,
//   "DispatchTypeId": 1,
//   "Company": "Fint hemma AB",
//   "Name": "Jenny Wijk",
//   "Department": null,
//   "POAddress": null,
//   "StreetAddress": "Kistahavetsväg 1B",
//   "ZipCode": "76492",
//   "City": "Väddö",
//   "State": null,
//   "Country": "SWEDEN",
//   "IsoCountryCode": "SE",
//   "Phone": "0734422350",
//   "Cellphone": null,
//   "Email": null,
//   "DeliveryMethodId": 1,
//   "DeliveryMethodName": "DPD Företagspaket 16.00 (kod 15)",
//   "PickingListId": 0,
//   "UnifaunPreparedId": null,
//   "DispatchOrderRows": [
//       {
//           "DispatchOrderRowId": 91,
//           "ProductId": "1000007",
//           "Product": "LEGO Star Wars AT-AT 75313",
//           "OrderedQty": 1,
//           "DispatchedQty": 0,
//           "ExternalDocumentRowId": null,
//           "ManufacturerProductId": "AT-AT 75313"
//       }
//   ],
//   "IsOnCommercialInvoice": false,
//   "ExternalWarehouseStatus": null
// }
export const useDispatchOrderAdditionalDataTable = (dispatchOrderData): [columns: GridColDef[], tableSettings: tableSettingsProps] => {
  //const rows = (dispatchOrderData == undefined || dispatchOrderData == null) ? [dispatchOrderData] : [] ;
  

  const rows = useMemo(() => {
    if (dispatchOrderData == undefined || dispatchOrderData == null) {
      return []
    }
    const rows = dispatchOrderData?.DispatchOrderRows?.map((row) => {
      return {
        ...dispatchOrderData,
        ...row,
      };
    });
 //   console.log("useDispatchOrderAdditionalDataTable rows", rows);
    return rows;
  }, [dispatchOrderData]);
 // console.log("useDispatchOrderAdditionalDataTable rows", rows);
  const columns: GridColDef[] = React.useMemo(
    () => [
      { field: 'DispatchOrderId', headerName: 'Id',  type:"number" },
      { field: 'Company', headerName: 'Company',   },
      { field: 'Name', headerName: 'Name', flex:1 },
      { field: 'Department', headerName: 'Department', flex:1 },
      { field: 'StreetAddress', headerName: 'Street Address', flex:1 },
      { field: 'ZipCode', headerName: 'Zip Code',  type:"number"},
      { field: 'City', headerName: 'City', flex:1 },
      { field: 'State', headerName: 'State' },
      { field: 'Country', headerName: 'Country' },
      { field: 'IsoCountryCode', headerName: 'Iso Country Code' },
      { field: 'Phone', headerName: 'Phone' },
      { field: 'Cellphone', headerName: 'Cellphone' },
      { field: 'Email', headerName: 'Email' },
      //IsOnCommercialInvoice
      { field: 'IsOnCommercialInvoice', headerName: 'Is On Commercial Invoice',  type:"boolean" },
      { field: 'ExternalWarehouseStatus', headerName: 'External Warehouse Status' },
      { field: 'DispatchOrderBlockId', headerName: 'Dispatch Order Block Id',  type:"number" },
      { field: 'DispatchOrderBlockReason', headerName: 'Dispatch Order Block Reason' },
      { field: 'Priority', headerName: 'Priority',  type:"number"},
      { field: 'DispatchTypeId', headerName: 'Dispatch Type Id',  type:"number"},
      { field: 'PickingListId', headerName: 'Picking List Id',  type:"number"},
      { field: 'UnifaunPreparedId', headerName: 'Unifaun Prepared Id' },

      
   
    ],
    [],
  );
  const tableName = "DispatchOrderAdditionalDataTable";
  const idPath=["DispatchOrderId"];
  const tableSettings = useTableSettings({ columns, rows, tableName , idPath});
  tableSettings.hasToolbar = false;
  tableSettings.autoHeight = true;
  tableSettings.loading = false;
  tableSettings.hideFooter = true;
  return [ columns, tableSettings];
};


